import { connect } from 'react-redux';

import { Entities, fetchAll, getEntities, patch, save } from 'src/common/index';
import EmailToJourneyAdministration from 'src/components/admin/email-to-journey/email-to-journey-administration';

const mapStateToProps = state => {
    return {
        emailToJourneyItems: getEntities(state, Entities.EMAIL_TO_OFFER),
    };
};

const EmailToJourneyAdministrationContainer = connect(mapStateToProps, { fetchAll, patch, save })(
    EmailToJourneyAdministration,
);

export default EmailToJourneyAdministrationContainer;
